import * as React from "react";
import { useMemo } from "react";
import { Nav } from "components/bootstrap";
import { isPermitted } from "util/PermissionsMixin";
import filterByPerspective from "components/perspectives/util/filterByPerspective";
import useCurrentUser from "hooks/useCurrentUser";
import useActivePerspective from "components/perspectives/hooks/useActivePerspective";
import usePluginEntities from "hooks/usePluginEntities";
import NavigationItem from "components/navigation/NavigationItem";
import { DEFAULT_SECURITY_NAV_ITEM } from "components/security/bindings";
import DEFAULT_ENTERPRISE_NAV_ITEM from "components/navigation/DefaultEnterpriseNavItem";
import sortNavigationItems from "components/navigation/util/sortNavigationItems";
import mergeNavigationItems from "./util/mergeNavigationItems";
const pluginMenuItemExists = (navigationItems, description) => {
  if (!(navigationItems == null ? void 0 : navigationItems.length)) {
    return false;
  }
  return !!navigationItems.find((value) => {
    var _a;
    return ((_a = value.description) == null ? void 0 : _a.toLowerCase()) === description.toLowerCase();
  });
};
const pluginLicenseValid = (navigationItems, description) => {
  if (!(navigationItems == null ? void 0 : navigationItems.length)) return false;
  const menuItem = navigationItems.find((value) => {
    var _a;
    return ((_a = value.description) == null ? void 0 : _a.toLowerCase()) === description.toLowerCase();
  });
  return menuItem && Object.keys(menuItem).includes("useCondition") ? menuItem.useCondition() : true;
};
const useNavigationItems = () => {
  const { permissions } = useCurrentUser();
  const { activePerspective } = useActivePerspective();
  const allNavigationItems = usePluginEntities("navigation");
  const navigationItems = useMemo(() => mergeNavigationItems(allNavigationItems), [allNavigationItems]);
  const securityLicenseInvalid = !pluginLicenseValid(navigationItems, DEFAULT_SECURITY_NAV_ITEM.description);
  return useMemo(() => {
    const enterpriseMenuIsMissing = !pluginMenuItemExists(navigationItems, DEFAULT_ENTERPRISE_NAV_ITEM.description);
    const securityMenuIsMissing = !pluginMenuItemExists(navigationItems, DEFAULT_SECURITY_NAV_ITEM.description);
    const isPermittedToEnterpriseOrSecurity = isPermitted(permissions, ["licenseinfos:read"]);
    if (enterpriseMenuIsMissing && isPermittedToEnterpriseOrSecurity) {
      navigationItems.push(DEFAULT_ENTERPRISE_NAV_ITEM);
    }
    if (securityMenuIsMissing && isPermittedToEnterpriseOrSecurity || securityLicenseInvalid) {
      if (!securityMenuIsMissing) {
        navigationItems.splice(
          navigationItems.findIndex((item) => item.description === DEFAULT_SECURITY_NAV_ITEM.description),
          1
        );
      }
      navigationItems.push(DEFAULT_SECURITY_NAV_ITEM);
    }
    const itemsForActivePerspective = filterByPerspective(navigationItems, activePerspective == null ? void 0 : activePerspective.id);
    return sortNavigationItems(itemsForActivePerspective);
  }, [activePerspective == null ? void 0 : activePerspective.id, navigationItems, permissions, securityLicenseInvalid]);
};
const MainNavbar = ({ pathname }) => {
  const navigationItems = useNavigationItems();
  return /* @__PURE__ */ React.createElement(Nav, { className: "navbar-main" }, navigationItems.map((navigationItem) => /* @__PURE__ */ React.createElement(NavigationItem, { navigationItem, pathname, key: navigationItem.description })));
};
export default MainNavbar;
